const appList = [
  {
    href: 'https://goqsystem.com/',
    img: 'goqsystem',
    favicon: 'goqsystem',
    name: 'GoQSystem',
    description: '通販業務を劇的に進化させる、クラウド型受注一元管理システム。'
  },
  {
    href: 'https://ranking.goqsystem.com/',
    img: 'ranking',
    favicon: 'ranking',
    name: 'GoQ無料ツール',
    description: '一度ご登録頂くだけで、全てのツールが完全無料でご利用可能！'
  },
  {
    href: 'https://goqsmile.com/',
    img: 'goqsmile',
    favicon: 'goqsmile',
    name: 'GoQSmile',
    description: 'だれでも、すぐに使える、直感的チャットボット。'
  },
  {
    href: 'https://goq.ma/',
    img: 'goqmieruca',
    favicon: 'goqma',
    name: 'GoQMieruca',
    description: 'あなたのサイトをだれがどこをどのくらいどう見たのかみえる化'
  },
  {
    href: 'https://goq.movie/',
    img: 'goqmovie',
    favicon: 'goqmovie',
    name: 'GoQMovie',
    description: 'アニメーション、実写、CGなど、動画制作〜運用まで提供！'
  }
]

export default appList
